import React from 'react';
import ReactDOM from 'react-dom';
import InsightsScroller from './components/InsightsScroller';

const { filters } = insightsScrollerData;
let { authors, topics, types } = filters;
topics = Object.values(topics).map(topic => ({
  id: topic.term_id,
  title: topic.name
}));
types = Object.values(types).map(type => ({
  id: type.term_id,
  title: type.name
}));
authors.map(author => ({ ...author, id: parseInt(author.id, 10) }));

const data = {
  ...insightsScrollerData,
  filters: { ...filters, topics, types }
};

window.onload = () =>
  ReactDOM.render(
    <InsightsScroller {...data} />,
    document.querySelector('.insights-scroller')
  );
